var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.63 11.36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37337d",
    d: "M13.63 5.21H1.86l4.5-4.5-.7-.71L0 5.66l.03.02-.03.03 5.66 5.65.7-.7-4.47-4.48h11.74v-.97z"
  })));
}

export default SvgArrowLeft;